import React, { useEffect, useState } from "react";
import Navbar from "./navbar";
import { useNavigate } from "react-router-dom";
import  './Resources/Actions.css';
import './App.css';


export default function Cashinhand()
{
    const [account,setAccount] = useState([]);
    const API_URL = process.env.REACT_APP_WEB_API_KEY;

    useEffect(()=>
    {
        fetch(API_URL+"api/Ledger/GetAccounts")
        .then(response => response.json())
        .then(data => {setAccount(data)});
    })

    const capitalaccount = account.filter((e)=>{if(e.AccountID === 1){return e;}})
    const drawingsaccount = account.filter((e)=>{if(e.AccountID === 2){return e;}})
    const cashaccount = account.filter((e)=>{if(e.AccountID === 3){return e;}})
    const loanaccount = account.filter((e)=>{if(e.AccountID === 4){return e;}})
    const interestaccount = account.filter((e)=>{if(e.AccountID === 5){return e;}})
    const fineaccount = account.filter((e)=>{if(e.AccountID === 6){return e;}})
    const documentaccount = account.filter((e)=>{if(e.AccountID === 7){return e;}})
    const expenseaccount = account.filter((e)=>{if(e.AccountID === 8){return e;}})
    
    return(
    <>
    <div className="reportheader"> 
            Cash Balance Report
            <Navbar/>
    </div>      
    
    <fieldset style={{marginTop:"2px",marginBottom:"2px"}}>
    <legend>Credit</legend>
    <table style={{width:"100%"}}>
        <tr>
            <td style={{textAlign:"left", width:"50%"}}>
            Capital
            </td>
            {capitalaccount.length > 0 ?
            <td id = "capital">{capitalaccount[0].CurrentCredit}</td> :
            <td id = "capital">0</td>}
        </tr>
        <tr>
            <td style={{textAlign:"left", width:"50%"}}>Interest</td>
            {interestaccount.length > 0 ? 
            <td id = "interest">{interestaccount[0].CurrentCredit}</td> :
            <td id = "interest"> 0 </td>}
        </tr>
        <tr>
            <td style={{textAlign:"left", width:"50%"}}>DocumentFee</td>
            {documentaccount.length > 0 ?
            <td id ="documentfee">{documentaccount[0].CurrentCredit}</td>:
            <td id ="documentfee" >0</td>}
        </tr>
        <tr>
            <td style={{textAlign:"left", width:"50%"}}>Fine</td>
            {fineaccount.length > 0 ? 
            <td id = "fine">{fineaccount[0].CurrentCredit}</td>
            :
            <td id = "fine">0</td>}
        </tr>
        
        <tr>
            <td style={{width:"50%",fontWeight:"bolder"}}>Credit Total</td>
            {capitalaccount.length > 0 ? 
            <td style={{fontWeight:"bolder"}}>{capitalaccount[0].CurrentCredit+interestaccount[0].CurrentCredit+documentaccount[0].CurrentCredit+fineaccount[0].CurrentCredit}</td>
            :
            <td id = "credit">0</td>}
            </tr>
    </table>
</fieldset>
<fieldset style={{marginBottom:"2px"}}>
    <legend>Debit </legend>
    <table style={{width:"100%"}}>
        <tr>
            <td style={{textAlign:"left", width:"50%"}}>
            Loan Balance
            </td>
            {loanaccount.length > 0 ?
            <td id='loanbalance'>{loanaccount[0].CurrentDebit - loanaccount[0].CurrentCredit}</td>:
            <td id='loanbalance'>0</td>}
        </tr>
        <tr>
            <td style={{textAlign:"left", width:"50%"}}>Expenses</td>
            {expenseaccount.length > 0 ?
            <td>{expenseaccount[0].CurrentDebit}</td>:
            <td>0</td>}
        </tr>
        
        <tr>
            <td style={{width:"50%",fontWeight:"bolder"}}>Debit Total</td>
            {capitalaccount.length > 0 ? 
            <td style={{fontWeight:"bolder"}}>{loanaccount[0].CurrentDebit - loanaccount[0].CurrentCredit+expenseaccount[0].CurrentDebit}</td>
            :
            <td id = "debit">0</td>}
            </tr>
            

    </table>
</fieldset>
<fieldset style={{marginBottom:"4px"}}>
    <legend>Closing</legend>
    <table style={{width:"100%"}}>
        <tr>
            <td style={{textAlign:"left", width:"50%"}}>Credit</td>
            {capitalaccount.length > 0 ? 
            <td style={{fontWeight:"bold"}}>{capitalaccount[0].CurrentCredit+interestaccount[0].CurrentCredit+documentaccount[0].CurrentCredit+fineaccount[0].CurrentCredit}</td>
            :
            <td id = "1">0</td>}
            </tr>
        <tr>
            <td style={{textAlign:"left", width:"50%"}}>Debit</td>
            {capitalaccount.length > 0 ? 
            <td style={{fontWeight:"bold"}}>{loanaccount[0].CurrentDebit - loanaccount[0].CurrentCredit+expenseaccount[0].CurrentDebit}</td>
            :
            <td id = "2">0</td>}
            </tr>
        
        <tr>
            <td style={{width:"50%",fontWeight:"bolder"}}>Cash Balance</td>
            {capitalaccount.length > 0 ? 
            <td id="dayclose" style={{fontWeight:"bolder"}}> {capitalaccount[0].CurrentCredit+interestaccount[0].CurrentCredit+documentaccount[0].CurrentCredit+fineaccount[0].CurrentCredit -(loanaccount[0].CurrentDebit - loanaccount[0].CurrentCredit+expenseaccount[0].CurrentDebit)} </td>
            :
            <td id = "3">0</td>}
            </tr>

    </table>
</fieldset>

</>
)
}